import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Small } from 'foundations-components/transitional/components/Small';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { useAppRelatedInstallStats } from '../../utils/hooks/useAppRelatedInstallStats';
import { HighlyEngagedLeadIcon } from 'foundations-assets/icons/components/HighlyEngagedLeadIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const AppRelatedInstallStatsSection = ({
  offeringId
}) => {
  const appRelatedInstallStats = useAppRelatedInstallStats(offeringId);
  const hasAppRelatedInstallStats = appRelatedInstallStats.country || appRelatedInstallStats.industry || appRelatedInstallStats.plan;
  return hasAppRelatedInstallStats && /*#__PURE__*/_jsx("div", {
    "data-test-id": "app-related-install-stats-section",
    children: /*#__PURE__*/_jsx(View, {
      backgroundColor: "fill-surface-recessed",
      borderColor: "border-core-subtle",
      borderRadius: "200",
      borderStyle: "solid",
      borderWidth: "100",
      "data-test-id": "app-related-install-stats-title",
      paddingBlock: "400",
      children: /*#__PURE__*/_jsxs(Flex, {
        flexDirection: "column",
        children: [/*#__PURE__*/_jsxs(Flex, {
          alignItems: "center",
          marginBlockEnd: "200",
          marginInlineStart: "500",
          children: [/*#__PURE__*/_jsx(View, {
            as: "span",
            marginInlineEnd: "300",
            paddingBlockStart: "100",
            children: /*#__PURE__*/_jsx(HighlyEngagedLeadIcon, {
              color: "fill-accent-orange-default",
              size: "600"
            })
          }), /*#__PURE__*/_jsx(Text, {
            as: "h6",
            marginBlockEnd: "0",
            children: /*#__PURE__*/_jsx(Small, {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "appMarketplace.detail.overview.sidebar.appRelatedInstallStats.title"
              })
            })
          })]
        }), /*#__PURE__*/_jsx(View, {
          paddingInline: "500",
          children: /*#__PURE__*/_jsx(List, {
            styled: true,
            margin: "0",
            paddingInlineStart: "500",
            children: Object.keys(appRelatedInstallStats).map(stat => {
              const statKey = stat; // have to force the type here
              if (!appRelatedInstallStats[statKey]) {
                return null;
              }
              const count = Object.values(appRelatedInstallStats[statKey])[0] || 0;
              const value = Object.keys(appRelatedInstallStats[statKey])[0];
              return /*#__PURE__*/_jsx(ListItem, {
                "data-test-id": `app-related-install-stats-${stat}-stat`,
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: `appMarketplace.detail.overview.sidebar.appRelatedInstallStats.${statKey}`,
                  options: {
                    count: I18n.formatNumber(Math.floor(count / 10) * 10),
                    value
                  }
                })
              }, stat);
            })
          })
        })]
      })
    })
  });
};